import React from 'react';

import PropTypes from 'prop-types';
import { Link } from 'react-router';

const ContentSubtitleWithLink = ({ subtitle, link, text }) => (
    <div className="text-center">
        { subtitle }
        { ' ' }
        { link && <Link to={link} className="link-primary">{text}</Link> }
    </div>
);

ContentSubtitleWithLink.propTypes = {
    subtitle: PropTypes.string,
    link: PropTypes.string,
    text: PropTypes.string,
};

export { ContentSubtitleWithLink };
